import * as React from "react";
import { useLocation } from "react-router";
import * as analytics from "@/services/analytics";
import { useGetAuthenticatedUserQuery } from "@/api/authentication";
import { isNotLoginRequired } from "@/helpers/auth";

analytics.init();

interface Props {
  children: React.ReactNode;
}

const useAnalyticsIdentify = () => {
  const { pathname } = useLocation();
  const isPublicRoute = isNotLoginRequired(pathname) || pathname.startsWith("/confirm-snapshot-event-status");

  const { data: user } = useGetAuthenticatedUserQuery(undefined, { skip: isPublicRoute });

  const email = user?.email;
  React.useEffect(() => {
    if (email) analytics.identify(email);
  }, [email]);
};

export const CSAnalyticsProvider: React.FC<Props> = ({ children }) => {
  useAnalyticsIdentify();
  return <>{children}</>;
};
